import React, {useState}  from 'react';
import Nav from './Nav';
import Footer from './Footer';
import './home.css';
import './Sales.css';
import { Link,useNavigate } from 'react-router-dom';
import { MdKeyboardBackspace } from "react-icons/md";
import DataTable from 'react-data-table-component';
import { Buffer } from 'buffer';
import useFetch from '../Components/UseFetch';
import {postedSalesInvoices} from '../HelperFx/datalinks';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {IconButton} from '@mui/material';
import { addCommas } from '../HelperFx/common.js';

import verifyToken from '../HelperFx/verifyJwt.js';

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
  // //Console.log(username);
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;

const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;


const eq = ' eq ';

const CustTable = () => {

  // const token = Buffer.from(`HRP:HRPbc@2023`, 'utf8').toString('base64');
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, 'utf8').toString('base64');
  // const token = Buffer.from(`HRP:HRPbc@2023`, 'utf8').toString('base64');
  const jwttoken = sessionStorage.getItem('authToken');
  const {custName,userName, password} = verifyToken(jwttoken);
  //Console.log(custName,userName, password);

  const { data: salesQuotes, loading, error } = useFetch(`${REACT_DATA_URL}${postedSalesInvoices}?${REACT_APP_COMPANY_URL}&$filter=customerNo${eq}'${custName}'`, token);
  const salesInvoiceInformation = salesQuotes?.value;

  console.log(salesInvoiceInformation);

  const navigate = useNavigate();

  const data = salesInvoiceInformation || [];

  const [searchTerm, setSearchTerm] = useState('');

  const columns = [
    { name: 'No.',
      selector: row =>
      (
        <span
          style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
          onClick={() => navigate(`/PostedPurchaseInvoice`,{state: {number: row.number}})}>
          {row.number}
        </span> 
      ),
      sortable: true },
    { name: 'Order No', selector: row => row.orderNo, sortable: true },
    { name: 'Customer No', selector: row => row.customerNo, sortable: true },
    { name: 'Customer Name', selector: row => row.customerName, sortable: true },
    { name: 'Currency', selector: row => row.currencyCode, sortable: true },
    { name: 'Amount LCY', selector: row => addCommas(row.AmountLcy), sortable: true },
  ];
  const filteredData = data.filter(item => 
    item.number.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.customerNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.WorkDescription.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* <h3>Posted Purchase Invoices</h3> */}
      <input
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className='table-search'
      />

      <DataTable
        // title="Items List"
        columns={columns}
        data={filteredData}
        pagination
      />
    </div>
  );
};

const PostedSalesInvoices = () => {
  return (
    <div className="Home">
      <Nav/>
      <div className="dash-main">
        <div className="squote">
          <div className="firsttab">
          <IconButton component={Link} to="/home">
              <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>
          {/* <Link to="/home"><MdKeyboardBackspace style={{ width: "50px"}}/></Link> */}

            <span>Posted Purchase Invoices</span>
          </div>

          <div className="listTable">
            <CustTable/>

          </div>
        </div>
      </div>
      <Footer/>
  </div>
  )
}

export default PostedSalesInvoices;